import { useState } from 'react';
import { useParams } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { EstadoCargando, EstadoError } from '@xiltrion/ui/bloques/estados';
import { usePedir } from '@xiltrion/ui/bloques/pedir';
import { GrupoAvatares } from '@xiltrion/ui/bloques/personas';
import { Button } from '@xiltrion/ui/button';
import { Icono, type NombreIcono } from '@xiltrion/ui/icono';
import { fondoEtiqueta } from '@xiltrion/ui/paleta';
import { apiPost } from '@/api/client';
import { avisarError, keys, useProject } from '@/api/hooks';
import { ViewHost } from './ViewHost';
import { ProjectSettings } from './ProjectSettings';

/** Un proyecto: encabezado y sus vistas (spec §3.1). */
export function ProjectPage() {
  const { projectId } = useParams();
  const qc = useQueryClient();
  const { data: project, isLoading, error, refetch } = useProject(projectId);
  const [settings, setSettings] = useState(false);
  const { pedir, dialogo } = usePedir();
  if (isLoading) return <div className="p-6"><EstadoCargando /></div>;
  if (error || !project) return <div className="p-6"><EstadoError error={error} onReintentar={() => void refetch()} /></div>;
  const invalidate = () => void qc.invalidateQueries({ queryKey: keys.project(project.id) });
  return (
    <>
      <ViewHost
        scope="project"
        project={project}
        views={project.views}
        lastViewId={project.lastViewId}
        taskQuery={{ projectId: project.id }}
        canManage={project.capabilities.manage}
        invalidateViews={invalidate}
        header={
          <div className="flex items-center gap-3 px-4 pt-3 pb-1">
            <span className={`flex size-8 items-center justify-center rounded-md text-white ${fondoEtiqueta(project.color)}`}><Icono nombre={project.icon as NombreIcono} className="size-5" /></span>
            <div className="min-w-0 flex-1">
              <h1 className="truncate text-lg font-semibold">{project.name}</h1>
            </div>
            <GrupoAvatares personas={project.members.map((m) => ({ id: m.userId, nombre: m.displayName, color: m.avatarColor, externo: m.external }))} />
            {project.capabilities.manage && (
              <Button variant="outline" size="sm" onClick={async () => {
                const name = await pedir({ titulo: 'Sección nueva', etiqueta: 'Nombre', textoConfirmar: 'Crear' });
                if (name) void apiPost(`/projects/${project.id}/sections`, { name, afterId: project.sections[project.sections.length - 1]?.id }).then(invalidate, avisarError);
              }}><Icono nombre="mdi:plus" />Agregar sección</Button>
            )}
            <Button variant="outline" size="sm" onClick={() => setSettings(true)}><Icono nombre="mdi:cog-outline" />{project.capabilities.manage ? 'Configurar' : 'Detalles'}</Button>
          </div>
        }
      />
      <ProjectSettings project={project} open={settings} onOpenChange={setSettings} />
      {dialogo}
    </>
  );
}
